import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../types';

const tryFetchLogTagsSelector = (state: AppState) => state.tryFetchLogTags;

export const selectLogTags = createSelector(tryFetchLogTagsSelector, state => {
  return state;
});
